import { required } from 'AppReact/schema';

export default {
    id: required('string'),
    docUrl: required('string'),
    docID: required('string'),
    type: required('string'),
}

export const defaultOptionalDocs = {
    id: '1',
    docUrl: '',
    docID: '',
    type: 'optional'
}
